import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  title: {
    margin: 0,
    marginTop: 10,
    fontSize: 16,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  arrowIcon: {
    fontSize: '1.3rem',
    color: theme.custom.darkBlue,
  },
  iconBtn: {
    '&.Mui-disabled': {
      opacity: '.3',
    },
  },
  emptyText: {
    display: 'block',
    fontSize: 15,
    marginBottom: 10,
    color: theme.custom.darkBlue,
    '&:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    },
  },
  bold: {
    fontWeight: 600,
  },
  greyish: {
    color: 'rgba(34, 64, 96, .5)',
  },
  emptyMessageIcon: {
    fontSize: '4rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '3.5rem',
    },
  },
}));
